module.exports = __webpack_public_path__ + "static/img/header3.21260c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header3.jpg
// module id = lL03
// module chunks = 1